import { mapEntitiesToOptions } from '@containers/entities/helpers';
import { getConfiguration } from '@helpers/utils';

const useGetSortedCourse = (selectedPublication, publicationCourses) => {
  const keywords = ["nivel"];
  const englishPriorityCurriculumIds = getConfiguration('englishPriorityCurriculumIds') || [];
  const courses = mapEntitiesToOptions(publicationCourses, { valueColumn: 'id', labelColumn: 'courseName' });

  if (englishPriorityCurriculumIds.includes(selectedPublication?.value)) {
    const sorted = [...courses].sort((a, b) => {
      const aHasKeyword = keywords.some(keyword => a.label.toLowerCase().includes(keyword));
      const bHasKeyword = keywords.some(keyword => b.label.toLowerCase().includes(keyword));

      if (!aHasKeyword && bHasKeyword) return -1;  // Non-keyword goes first
      if (aHasKeyword && !bHasKeyword) return 1;   // keyword goes after

      return a.label.localeCompare(b.label);
    });
    return sorted;
  }
  return courses;
}

export default useGetSortedCourse